import { useOthers, useSelf } from "@liveblocks/react"
import { ErrorBoundary } from "@prismicio/editor-ui"
import { Suspense } from "react"

import { AvatarStack } from "../collaboration/AvatarStack"
import { useCollaborationState } from "../collaboration/CollaborationStateProvider"
import {
  useFilterOutSuperAdmins,
  useSelfIfNotSuperAdmin,
} from "../collaboration/utils"

export function CollaborationAvatarStack() {
  const collaborationState = useCollaborationState()

  if (!collaborationState.enabled) return null

  // We create a new error boundary and suspense block to avoid
  // breaking or having other features await the loading of the
  // CollaborationAvatarStack component data.
  return (
    <ErrorBoundary>
      <Suspense>
        <CollabAvatarStack />
      </Suspense>
    </ErrorBoundary>
  )
}

function CollabAvatarStack() {
  const self = useSelf() ?? undefined
  const others = useOthers()
  const othersWithoutSuperAdmins = useFilterOutSuperAdmins(others)
  const selfIfNotSuperAdmin = useSelfIfNotSuperAdmin(self)

  return (
    <AvatarStack others={othersWithoutSuperAdmins} self={selfIfNotSuperAdmin} />
  )
}
